module.exports = __webpack_public_path__ + "static/img/2.b7047a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting711/images/2.png
// module id = izyk
// module chunks = 4